module.exports = __webpack_public_path__ + "img/n1-press.f0c67ef4.png";